export const MicrosoftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 23 23" fill="none">
    <path d="M0 0H11V11H0V0Z" fill="#F25022" />
    <path d="M12 0H23V11H12V0Z" fill="#7FBA00" />
    <path d="M0 12H11V23H0V12Z" fill="#00A4EF" />
    <path d="M12 12H23V23H12V12Z" fill="#FFB900" />
  </svg>
);
